import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="avatar"
export default class extends Controller {
  static targets = ["fileInput", "canvas"]

  connect() {
    const imageUrl = this.canvasTarget.dataset.imageUrl
    if (imageUrl) {
      this.loadAndDrawImage(imageUrl)
    }
  }

  chooseFile() {
    this.fileInputTarget.click()
  }

  previewImage() {
    const file = this.fileInputTarget.files[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = (e) => {
      this.loadAndDrawImage(e.target.result)
    }
    reader.readAsDataURL(file)
  }

  loadAndDrawImage(url) {
    const img = new Image()
    img.onload = () => {
      const canvas = this.canvasTarget
      const ctx = canvas.getContext("2d")

      const size = Math.min(img.width, img.height)
      const sx = (img.width - size) / 2
      const sy = (img.height - size) / 2

      const displaySize = 200
      canvas.width = displaySize
      canvas.height = displaySize

      ctx.clearRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(img, sx, sy, size, size, 0, 0, displaySize, displaySize)
    }

    img.src = url
  }

  // beforeSubmit(event) {
  //   const canvas = this.canvasTarget
  //   const dataURL = canvas.toDataURL("image/jpeg")
  //
  //   const hidden = document.createElement("input")
  //   hidden.type = "hidden"
  //   hidden.name = "avatar_canvas_data"
  //   hidden.value = dataURL
  //   event.target.appendChild(hidden)
  // }
}
